// companies.js — Validación de nombres de compañías aseguradoras.
//
// Por qué existe: la IA, al extraer un siniestro o una deuda, a veces pone en el
// campo "compañía" el nombre del cliente o de una empresa tercera (ej. el nombre
// del taller, o de la empresa asegurada) en vez de la aseguradora real. Esto
// permite auditar: si el valor no se parece a ninguna aseguradora conocida del
// mercado uruguayo, lo tratamos como NO confiable (vacío + alerta de revisión).

// Aseguradoras del mercado uruguayo con las que trabaja la corredora.
// Cada entrada: forma canónica + palabras clave que la identifican.
const ASEGURADORAS = [
  { canon: 'BSE',          keys: ['bse', 'banco de seguros'] },
  { canon: 'Sura',         keys: ['sura'] },
  { canon: 'Mapfre',       keys: ['mapfre'] },
  { canon: 'Porto Seguro', keys: ['porto'] },
  { canon: 'Sancor',       keys: ['sancor'] },
  { canon: 'Berkley',      keys: ['berkley', 'berkely'] },
  { canon: 'SBI',          keys: ['sbi'] },
  { canon: 'Barbuss',      keys: ['barbuss', 'barbus'] },
  { canon: 'San Cristóbal',keys: ['san cristobal', 'san cris'] },
  { canon: 'Surco',        keys: ['surco'] },
  { canon: 'MetLife',      keys: ['metlife', 'met life'] },
  { canon: 'Zurich',       keys: ['zurich'] },
  { canon: 'HDI',          keys: ['hdi'] },
];

const norm = (s) => String(s || '')
  .toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

/**
 * Devuelve el nombre canónico de la aseguradora si el texto coincide con alguna
 * conocida, o null si no se reconoce (probable nombre de cliente/empresa).
 * @param {string} texto
 * @returns {string|null}
 */
export function companiaCanonica(texto) {
  const t = norm(texto);
  if (!t) return null;
  for (const a of ASEGURADORAS) {
    if (a.keys.some(k => t.includes(k))) return a.canon;
  }
  return null;
}

/**
 * ¿El texto corresponde a una aseguradora conocida?
 * @param {string} texto
 * @returns {boolean}
 */
export function esCompaniaValida(texto) {
  return companiaCanonica(texto) !== null;
}

/** Lista de nombres canónicos (para selects, datalists, etc.). */
export function listaCompanias() {
  return ASEGURADORAS.map(a => a.canon);
}
